import React from "react";
import styled, { keyframes } from "styled-components";
import { Box } from "@vinomofo/components";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 10px rgba(72, 169, 15, 0.2);
  }
  50% {
    box-shadow: 0 0 20px rgba(72, 169, 15, 0.7);
  }
  100% {
    box-shadow: 0 0 10px rgba(72, 169, 15, 0.2);
  }
`;

const GlowingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  padding: 6px 0px;
  opacity: 1;
`;

const Dot = styled(Box)`
  width: 10px;
  height: 10px;
  background-color: #48a90f;
  border-radius: 50%;
  position: relative;
  box-shadow: 0 0 5px rgba(72, 169, 15, 1);

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 10px rgba(72, 169, 15, 0.7);
    animation: ${pulse} 2s infinite;
  }
`;

const GlowingDot: React.FC = () => {
  return (
    <GlowingContainer>
      <Dot />
    </GlowingContainer>
  );
};

export default GlowingDot;
